import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
//outsource
import { Row, Col, Modal, Button, Checkbox, Form } from "antd";
// import { BRAND_NAME } from "../../../../config/config";
// import { GENERAL_INFO } from "../../../../store/data/data";

//components
import DialogConsultationAlert from "./dialog_consultation_alert";
import DialogConsultationAlert2 from "./dialog_consultation_alert2";
// import ConsultationStep from "./component/booking_step";
import SelectService from "./component/select_service";
import SelectedServices from "./component/selected_service";
import SelectedDateTime from "./component/selected_datetime";
import SelectFullDate from "./component/select_full_date";
import SelectInformation from "./component/select_info";
import DialogCustomerPolicy from "./dialog_customer_policy";

//redux
import {
  selectServiceSelector,
  fullDateSelector,
  stepSelector,
} from "../../../../store/service/service.selector";
import {
  addConsultationInfo,
  selectFullDateService,
  selectService,
  selectStepService,
  sendMediaToTelegram,
  sendMessageToTelegram,
  sendPhotoToTelegram,
} from "../../../../store/service/service.action";
import { generateMessage } from "../util/general.function";
// import { branchDetailBySlugSelector } from "../../../../store/branch/branch.selector";
import { AVAILABLE_TIME } from "../../../../store/data/group";
import { getUrlFromStorage } from "../util/media.function";
import DialogConsultationSuccess from "./dialog_consultation_success";

const stepTitles = [
  "Which services are you interested in?",
  "Schedule your consultation call",
  "Customer Information",
];

const dateFormat = "DD/MM/YYYY";

const DialogConsultationAdd = (props) => {
  // -------------------------- VAR --------------------------
  const { open, setOpen, setOpenCancel, group } = props;
  const [form] = Form.useForm();
  // -------------------------- STATE --------------------------
  const [uri, setUri] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [openSecondAlert, setOpenSecondAlert] = useState(false);
  const [photoRaw, setPhotoRaw] = useState([]);
  const [openCustomer, setOpenCustomer] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [selected, setSelected] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [full, setFull] = useState({
    date: moment().add(3, "days").format(dateFormat),
    time: AVAILABLE_TIME[0],
  });

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();

  const step = useSelector(stepSelector);
  const selectedService = useSelector(selectServiceSelector);
  const selectedDatetime = useSelector(fullDateSelector);
  // const branchDetail = useSelector(branchDetailBySlugSelector);

  // -------------------------- FUNCTION -----------------------
  const handleConfirmAlert = () => {
    setOpenAlert(false);
    setDisabled(true);
    setFull({
      date: moment().add(3, "days").format(dateFormat),
      time: AVAILABLE_TIME[0],
    });
    selectStepService(dispatch, 1);
  };

  const handleConfirmSecondAlert = () => {
    setOpenSecondAlert(false);
    setDisabled(true);
    setFull({
      date: moment().add(3, "days").format(dateFormat),
      time: AVAILABLE_TIME[0],
    });
    selectStepService(dispatch, 1);
  };

  const handleBack = () => {
    const previous = step >= 1 ? step - 1 : step;
    selectStepService(dispatch, previous);
    setDisabled(true);
  };

  const handleNext = () => {
    const next = step <= 1 ? step + 1 : step;
    selectStepService(dispatch, next);
    document.getElementsByClassName("ant-modal-wrap")[0].scrollTo((0, 0), 100);
  };

  const handleClose = () => {
    setLoading(false);
    setOpen(false);
    setSelected([]);
    setDisabled(true);
    setFull({
      date: moment().add(2, "days").format(dateFormat),
      time: AVAILABLE_TIME[0],
    });
    setUri("");
    form.resetFields();
    selectStepService(dispatch, 0);
  };

  const handleCheck = (e) => {
    const checked = e.target.checked;
    checked ? setDisabled(false) : setDisabled(true);
  };

  const onFinish = (values) => {
    console.log({ values, photoRaw });
    setLoading(true);
    const services = selectedService?.map((item) => item.name) || [];
    // const photoFiles = values.photo || [];

    const time = selectedDatetime;
    const fullDate = moment(time).format(dateFormat);

    const photoToUse = photoRaw;

    console.log(">>> photoToUse BEFORE dataRaw:", photoToUse);

    const dataRaw = {
      ...values,
      services,
      fullDate,
      time: full?.time,
      photo: photoRaw,
    };

    if (services?.length > 0 && time) {
      console.log("dataRaw", dataRaw);
      addRecord({ data: dataRaw, photo: photoToUse });
    }
  };

  const addRecord = useCallback(
    ({ data, photo }) => {
      console.log({ data, photo });
      const message = generateMessage({ data });
      const photoItems = photo; // this is your fileList array
      const files = photoItems?.map(
        (item) =>
          // if you use AntD Upload:
          // item.originFileObj
          // or if you used the custom images state:
          item.file,
      );
      dispatch(
        addConsultationInfo({ data, image: files }, async (info) => {
          console.log({ info });
          const urls = [];
          const paths = info?.data?.photo;
          for (let i = 0; i < paths?.length; i++) {
            const path = paths[i];
            if (path) {
              const url = await getUrlFromStorage({ path });
              urls.push(url);
            }
            console.log({ url: urls });
          }
          if (urls?.length > 0) {
            dispatch(
              sendMediaToTelegram({ message, photoUrls: urls }, (res) => {
                // console.log({ res });
                setLoading(false);
                setOpen(false);
                setSelected([]);
                setDisabled(true);
                setFull({
                  date: moment().add(2, "days").format(dateFormat),
                  time: AVAILABLE_TIME[0],
                });
                setUri("");
                form.resetFields();
                selectStepService(dispatch, 0);
                if (res?.data?.status === 200) {
                  window.location.href = "https://tbbsalon.co.nz/thank-you-2/";
                }
              }),
            );
          } else {
            dispatch(
              sendMessageToTelegram({ message }, (res) => {
                // console.log({ res });
                setLoading(false);
                setOpen(false);
                setSelected([]);
                setDisabled(true);
                setFull({
                  date: moment().add(2, "days").format(dateFormat),
                  time: AVAILABLE_TIME[0],
                });
                setUri("");
                form.resetFields();
                selectStepService(dispatch, 0);
                if (res?.data?.status === 200) {
                  window.location.href = "https://tbbsalon.co.nz/thank-you-2/";
                }
              }),
            );
          }
        }),
      );
    },

    [form, dispatch],
  );

  const onFinishFailed = (err) => {
    console.log("err", err);
  };

  // -------------------------- EFFECT --------------------------
  //Select Date
  useEffect(() => {
    if (full?.date !== "" && full?.time !== "") {
      const datestring = `${full?.date}`;
      const fullDate = moment(datestring, dateFormat).toDate();
      selectFullDateService(dispatch, fullDate);
    } else {
      const today = moment().toDate();
      selectFullDateService(dispatch, today);
    }
    const today = moment().format(dateFormat);
    const tmr = moment().add(1, "day").format(dateFormat);
    const now = moment();
    const target = moment(`${today} 04:00 PM`, dateFormat);
    const isDiff = target.diff(now, "minutes");

    if (full?.date !== "" && full?.date === today) {
      setOpenAlert(true);
    }

    if (full?.date !== "" && full?.date === tmr && isDiff <= 0) {
      setOpenSecondAlert(true);
    }
  }, [full]);

  //SeLect services
  useEffect(() => {
    if (selected) {
      selectService(dispatch, selected);
    }
  }, [dispatch, selected]);

  // -------------------------- RENDER --------------------------
  const renderModalContent = () => {
    return (
      <Row>
        <Col span={24}>{renderBody()}</Col>
      </Row>
    );
  };

  // ####-------- BODY --------- ####//
  const renderBody = () => {
    return (
      <Row gutter={[20]}>
        <Col xs={24} sm={24} md={24} lg={14} xl={14} xxl={14}>
          {renderSelectConsultation()}
        </Col>
        <Col align="center" xs={24} sm={24} md={24} lg={10} xl={10} xxl={10}>
          {renderServiceSelected()}
          {step !== 0 ? renderDateTime() : null}
          {renderNote()}
          {step === 2 ? renderConfirm() : null}
        </Col>
      </Row>
    );
  };

  const renderNote = () => {
    return (
      <>
        <div className="note-booking">
          Note: We will give you a call at your scheduled time - and this
          consultation is completely free.
        </div>
      </>
    );
  };

  const renderSelectConsultation = () => {
    switch (step) {
      case 0:
        return (
          <SelectService
            group={group}
            selected={selected}
            setSelected={setSelected}
            selectedService={selectedService}
          />
        );
      case 1:
        return <SelectFullDate full={full} setFull={setFull} />;

      default:
        return (
          <SelectInformation
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            onPhotosChange={setPhotoRaw}
          />
        );
    }
  };

  const renderServiceSelected = () => {
    return <SelectedServices selectedService={selectedService} />;
  };

  const renderDateTime = () => {
    return <SelectedDateTime selectedDatetime={selectedDatetime} full={full} />;
  };

  const renderFooter = () => {
    return (
      <Row gutter={[20]}>
        <Col align="left" span={12}>
          {step === 0 ? null : renderButtonBack()}
        </Col>
        <Col span={12}>
          {step === 2 ? renderButtonConfirm() : renderButtonContinue()}
        </Col>
      </Row>
    );
  };

  const renderButtonBack = () => {
    return (
      <Button
        onClick={handleBack}
        className="btn-booking-cancel"
        type="default"
        loading={loading}
      >
        Back
      </Button>
    );
  };

  const renderButtonContinue = () => {
    const invalidStepOne = step === 0 && selectedService?.length === 0;

    const todayStart = moment().startOf("day");
    const selectedDayStart = moment(selectedDatetime).startOf("day");
    const invalidStepTwo = step === 1 && selectedDayStart.isBefore(todayStart);

    const invalidStep = invalidStepOne || invalidStepTwo;
    console.log({
      invalidStep,
      step,
      invalidStepOne,
      invalidStepTwo,
      selectedService,
    });

    return (
      <Button
        onClick={handleNext}
        className={
          invalidStep ? "btn-booking-continue-disabled" : "btn-booking-continue"
        }
        type="primary"
        loading={loading}
        disabled={invalidStep}
      >
        Continue
      </Button>
    );
  };
  //   // Step 0: must pick at least one service
  //   const noServiceSelected = step === 0 && selectedService.length === 0;

  //   // Step 1: disable only if the chosen date-time is before *now*
  //   const now = moment();
  //   const isDateInPast = moment(selectedDatetime).isBefore(now);
  //   const invalidDateSelection = step === 1 && isDateInPast;

  //   // combine both rules
  //   const isContinueDisabled = noServiceSelected || invalidDateSelection;

  //   return (
  //     <Button
  //       onClick={handleNext}
  //       type="primary"
  //       loading={loading}
  //       disabled={isContinueDisabled}
  //       className={
  //         isContinueDisabled
  //           ? "btn-booking-continue-disabled"
  //           : "btn-booking-continue"
  //       }
  //     >
  //       Continue
  //     </Button>
  //   );
  // };

  const renderButtonConfirm = () => {
    return (
      <Button
        form="consultation"
        htmlType="submit"
        className={
          disabled ? "btn-booking-confirm-disabled" : "btn-booking-confirm"
        }
        type="primary"
        disabled={disabled}
        loading={loading}
      >
        Confirm Consultation
      </Button>
    );
  };

  const renderAlertDialog = () => {
    return (
      <>
        <DialogConsultationAlert
          open={openAlert}
          setOpen={setOpenAlert}
          handleConfirmAlert={handleConfirmAlert}
        />
        <DialogConsultationAlert2
          open={openSecondAlert}
          setOpen={setOpenSecondAlert}
          handleConfirmAlert={handleConfirmSecondAlert}
        />
      </>
    );
  };

  const renderDialogCustomerPolicy = () => {
    return (
      <DialogCustomerPolicy open={openCustomer} setOpen={setOpenCustomer} />
    );
  };

  const renderConfirm = () => {
    return (
      <Row style={{ marginTop: "1rem" }} gutter={[20]}>
        <Col span={1}>
          <Checkbox onChange={(e) => handleCheck(e)} />
        </Col>
        <Col align="left" span={20}>
          I have read and agree to{" "}
          <a
            target="_blank"
            className="btn-link"
            onClick={() => setOpenCustomer(true)}
          >
            Customer policy
          </a>
          .
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <>
      {renderAlertDialog()}
      {renderDialogCustomerPolicy()}
      <Modal
        className="modal-booking"
        open={open}
        title={stepTitles[step]}
        width={900}
        footer={renderFooter()}
        onCancel={handleClose}
      >
        <Form
          id="consultation"
          type="basic"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          validateTrigger="onFinish"
        >
          {renderModalContent()}
        </Form>
      </Modal>
      <DialogConsultationSuccess
        open={openSuccess}
        setOpenSuccess={setOpenSuccess}
      />
    </>
  );
};

export default DialogConsultationAdd;
